var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8295 40.0781C25.8295 40.7868 26.111 41.4664 26.6121 41.9674C27.1132 42.4685 27.7928 42.75 28.5014 42.75C29.21 42.75 29.8896 42.4685 30.3907 41.9674C30.8918 41.4664 31.1733 40.7868 31.1733 40.0781C31.1733 39.3695 30.8918 38.6899 30.3907 38.1888C29.8896 37.6878 29.21 37.4062 28.5014 37.4062C27.7928 37.4062 27.1132 37.6878 26.6121 38.1888C26.111 38.6899 25.8295 39.3695 25.8295 40.0781ZM26.7202 23.1562V33.3984C26.7202 33.6434 26.9206 33.8438 27.1655 33.8438H29.8373C30.0823 33.8438 30.2827 33.6434 30.2827 33.3984V23.1562C30.2827 22.9113 30.0823 22.7109 29.8373 22.7109H27.1655C26.9206 22.7109 26.7202 22.9113 26.7202 23.1562ZM53.1996 47.6484L30.0433 7.57031C29.6982 6.97471 29.1026 6.67969 28.5014 6.67969C27.9002 6.67969 27.2991 6.97471 26.9595 7.57031L3.80327 47.6484C3.1186 48.8396 3.97582 50.3203 5.34516 50.3203H51.6577C53.027 50.3203 53.8842 48.8396 53.1996 47.6484ZM9.58676 46.0954L28.5014 13.3538L47.4161 46.0954H9.58676Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.752f562ab5c2e3b45c15ad6259db8a8f.svg";
export { ForwardRef as ReactComponent };